(() => {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.els();
      this.settings();
      this.listeners();
    }

    settings() {
      this.isOpen = false;
      this.loadingClass = 'search--loading';
      this.toggledBeforeInit = document.documentElement.classList.contains(this.loadingClass);
      this.swiperLoading = false;
    }

    els() {
      this.activeToggleEl = null;
      this.closeEls = document.querySelectorAll('[data-search-menu-close]');
      this.mobileFormEl = document.querySelector('#mobileMenuSearchForm');
      this.queryEls = document.querySelectorAll('[data-search-menu-query]');
      this.toggleEls = document.querySelectorAll('[data-search-menu-toggle]');
    }

    initSwiper() {
      const needsUpdate = document.querySelector('#klevuSearchingArea .cards:not(.swiper-initialized) .product-card');
      if (!needsUpdate) return;

      requestAnimationFrame(() => {
        if (this.swiperLoading) return;

        this.swiperLoading = true;
        window.loadSwiper();

        requestAnimationFrame(() => {
          this.swiperLoading = false;
        });
      });
    }

    listeners() {
      this.toggleEls.forEach(el => {
        el.addEventListener('click', e => {
          e.preventDefault();
          this.activeToggleEl = el;
          this.open();
        });
      });

      window.searchFormIsInit = true;

      this.closeEls.forEach(el => {
        el.addEventListener('click', () => {
          this.close();
        });
      });

      // ESC key close
      window.addEventListener('keydown', e => {
        if (!(e.key === 'Escape' && (document.documentElement.classList.contains('search-menu--active') || document.documentElement.classList.contains('search-menu--focused')))) return;
        this.close();
        this.hideKlevu();
      });

      // Close search menu on clicks outside of it
      document.addEventListener('click', e => {
        if (!window.matchMedia('(min-width: 1024px)').matches) return;
        const isNotSearchClick = !e.target.closest('search-form') && !e.target.closest('.kuQuickSearchResultsContainer') && !e.target.closest('[data-search-menu-toggle]');
        if (isNotSearchClick && document.documentElement.classList.contains('search-menu--active')) {
          this.close();
        }
      });

      if (this.toggledBeforeInit) {
        this.open();
      }

      if (!this.queryEls) return;

      this.queryEls.forEach(el => {
        el.addEventListener('focus', () => {
          this.open();
        });

        el.addEventListener('click', e => {
          e.preventDefault();
          this.open();
        });

        el.addEventListener('input', debounce(() => {
          this.open();
        }, 250), { passive: true });
      });
    }

    close() {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        if (this.activeToggleEl) this.activeToggleEl.focus();
      } else {
        this.hideKlevu();
        document.body.click();
      }

      document.documentElement.classList.remove('search-menu--active');
      document.documentElement.classList.remove('search-menu--focused');
      lockScrollDisable();

      if (this.visibleQueryEl) this.visibleQueryEl.value = '';
      this.isOpen = false;
      this.activeToggleEl = null;
    }

    hideKlevu() {
      const klevuResultsEl = document.querySelector('.kuQuickSearchResultsContainer');
      if (klevuResultsEl) klevuResultsEl.style.display = 'none';
    }

    isVisible(el) {
      return el && el.offsetParent !== null;
    }

    isKlevuVisible() {
      return this.isVisible(document.querySelector('.kuQuickSearchResultsContainer'));
    }

    open() {
      if (this.isOpen) return;

      this.isOpen = true;

      const klevuResultsEl = document.querySelector('.kuQuickSearchResultsContainer');
      if (klevuResultsEl) klevuResultsEl.style.display = null;

      document.documentElement.classList.add('search-menu--focused');
      document.documentElement.classList.add('search-menu--active');

      setTimeout(() => {
        if (this.isKlevuVisible()) {
          lockScrollEnable();
        }
      }, 300);

      requestAnimationFrame(() => {
        this.visibleQueryEl = Array.from(this.queryEls).find(el => this.isVisible(el));
        this.triggerFocus();
      });

      document.documentElement.classList.remove(this.loadingClass);
    }

    triggerFocus() {
      if (this.visibleQueryEl !== document.activeElement) {
        this.visibleQueryEl.focus();
      }

      requestAnimationFrame(() => {
        this.visibleQueryEl.dispatchEvent(new CustomEvent('focus'), { bubbles: true });
      });
    }
  }

  if (!customElements.get('search-form')) {
    customElements.define('search-form', SearchForm);
  }
})();